import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface MidPageCtaProps {
  prompt?: string;
  bgClass?: string;
}
export function MidPageCta({
  prompt = 'Ready to feel prepared?',
  bgClass = 'bg-warm-white'
}: MidPageCtaProps) {
  return <section className={`w-full py-12 px-6 ${bgClass}`} data-id="element-107">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-4xl mx-auto text-center" data-id="element-108">
        <p className="text-xl md:text-2xl font-serif text-navy mb-6 font-medium" data-id="element-109">
          {prompt}
        </p>

        <div className="flex flex-col items-center" data-id="element-110">
          <a href="https://www.betterbysteps.com/cart/44200151777373:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-navy rounded-full overflow-hidden transition-transform hover:scale-[1.02] shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy" data-id="element-111">
            <span data-id="element-112">
              Get the Binder —{' '}
              <span className="line-through opacity-60 mr-1" data-id="element-113">$17</span> $6.36
            </span>
            <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-114" />
          </a>
          <p className="mt-3 text-sm text-muted" data-id="element-115">
            Instant PDF download.{' '}
            <span className="text-teal font-semibold" data-id="element-116">You save $10.64</span>
          </p>
        </div>
      </motion.div>
    </section>;
}